<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h1>Groups</h1>

            <div>
                <button
                    class="btn btn-primary float-right"
                    @click="startCreate"
                >
                    Create Group
                </button>
            </div>
        </div>

        <group-modal
            :group="modal.group"
            @save="saveGroup"
        />
        
        <delete-warning-modal
            title="Are you sure you want to delete this group?"
            description="Please note that by doing so, all patient enrollment data related to this group will be removed as well. This can not be reversed."
            @delete="deleteGroup"
        />

        <table class="table">
            <thead>
                <tr>
                    <th
                        scope="col"
                        style="width: 90%"
                    >
                        Name
                    </th>
                    <th
                        style="width: 10%"
                        scope="col"
                    >
                        &nbsp;
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="group in groups"
                    :key="group.id"
                >
                    <td>{{ group.name }}</td>

                    <td>
                        <font-awesome-icon
                            icon="edit"
                            class="clickable"
                            @click="startEdit(group)"
                        />

                        <font-awesome-icon
                            icon="trash"
                            class="clickable ml-2"
                            @click="startDelete(group)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import DeleteWarningModal from '../components/DeleteWarningModal.vue';
import GroupModal from '../components/GroupModal.vue';

import groupService from '../services/group.service';

export default {
    name: 'Groups',

    components: {
        GroupModal,
        DeleteWarningModal,
    },

    data() {
        return {
            isLoading: false,
            groups: [],
            modal: {
                group: {
                    name: '',
                },
            },
        };
    },

    mounted() {
        this.getGroups().then((r) => {
            this.groups = r.data;
            this.isLoading = false;
        });
    },

    methods: {
        getGroups: groupService.getGroups,

        startCreate() {
            this.modal.group = {
                name: '',
            };

            this.$modal.show('group');
        },

        startEdit(group) {
            this.modal.group = group;

            this.$modal.show('group');
        },

        startDelete(group) {
            this.modal.group = group;

            this.$modal.show('delete-warning');
        },

        async saveGroup() {
            if (this.modal.group.id == null) {
                await groupService.createGroup(this.modal.group).then((r) => {
                    this.modal.group.id = r.data.id;

                    this.groups.push(this.modal.group);

                    this.$modal.hide('group');

                    this.$toastr.s('The group was created successfully.');
                }).catch(() => {
                    this.$toastr.e('Unable to create the group, please try again...');
                });

                return;
            }

            await groupService.updateGroup(this.modal.group).then(() => {
                this.$modal.hide('group');

                this.$toastr.s('The group was updated successfully.');
            }).catch(() => {
                this.$toastr.e('Unable to update the group, please try again...');
            });
        },

        async deleteGroup() {
            await groupService.deleteGroup(this.modal.group.id).then(() => {
                this.groups = this._.filter(this.groups, (s) => s.id !== this.modal.group.id);

                this.$modal.hide('delete-warning');

                this.$toastr.s('The group was deleted successfully.');
            }).catch(() => {
                this.$toastr.e('Unable to delete the group, please try again...');
            });
        },
    },
};
</script>

<style>

</style>
